<template>
  <b-tag v-if="assassins" type="is-danger">Ass.</b-tag>
  <b-tag v-else type="is-light">Bers.</b-tag>
</template>

<script>
export default {
  name: "StatTag",
  props: ['assassins'],
}
</script>

<style scoped>

</style>